module.exports = __webpack_public_path__ + "static/media/x-rays.637206a3.svg";